module.exports = __webpack_public_path__ + "img/cabinet-barry.19c50d5f.jpg";